import { TableCell, TableRow, Typography } from '@mui/material';
import { OfflineBudgetNestedTableRowData } from 'pages/calculator/MediaPlanning/common/BudgetTable/interfaces';
import { formatNumberWithSpaces } from 'pages/calculator/MediaPlanning/common/BudgetTable/utils/formatNumberWithSpaces';

interface TvTouchpointTableRowProps {
  row: OfflineBudgetNestedTableRowData;
}

function TvTouchpointTableRow({ row }: TvTouchpointTableRowProps) {
  return (
    <TableRow>
      <TableCell>
        <Typography variant="body2">{row.copy?.name}</Typography>
      </TableCell>
      <TableCell />
      <TableCell />
      <TableCell>
        <Typography variant="body2" align="right">
          {formatNumberWithSpaces(row.grp)}
        </Typography>
      </TableCell>
      <TableCell align="right">
        <Typography variant="body2">
          {row.split ? `${row.split}%` : 'N/A'}
        </Typography>
      </TableCell>
      <TableCell align="right">
        <Typography variant="body2">{row.weeks ? row.weeks : 'N/A'}</Typography>
      </TableCell>
      <TableCell align="right">
        <Typography variant="body2">
          {`${formatNumberWithSpaces(row.budget.value.toFixed(0))} ${
            row.budget.currency
          }`}
        </Typography>
      </TableCell>
    </TableRow>
  );
}

export default TvTouchpointTableRow;
